/**
 * Centralised registry of "publish target" apps — i.e. external content
 * platforms that we publish blog drafts to. Adding a new target (LinkedIn,
 * Medium, etc.) means landing one entry here plus the matching backend app.
 *
 * Each target maps to:
 * - `appName`        — the workflow-app `short_name`, used to look up the
 *                      tenant credential and to address app actions.
 * - `publishAction`  — name of the action that creates a post.
 * - `fetchAction`    — name of the action used for the freshness check.
 * - `validationAction` — name of the action used by the connect-modal to
 *                        validate user-typed credentials before saving.
 */
export const PUBLISH_TARGETS = {
    wordpress: {
        appName: 'wordpress',
        publishAction: 'publish_post',
        fetchAction: 'get_post',
        validationAction: 'get_user_info',
        getCategoriesAction: 'get_categories',
        getTagsAction: 'get_tags',
        uploadMediaAction: 'upload_media',
    },
} as const

export type PublishTargetName = keyof typeof PUBLISH_TARGETS
